import React from "react";

import styled from "styled-components/macro";

const BrowserTopBar = styled.div`
  height: 36px;
  border-radius: 5px 5px 0 0;
  background-color: #fff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  padding: 0 10px;

  .circle {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;

    &.close {
      background-color: #ff554f;
    }

    &.minimize {
      background-color: #ffc02f;
    }

    &.fullscreen {
      background-color: #29cf42;
    }
  }
`;

const UrlBar = styled.div`
  font-size: 12px;
  margin-left: 10px;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 3px 10px;
  flex-grow: 1;
`;

const BrowserLayout = ({ url, children }) => (
  <div style={{ marginRight: 1 }}>
    <BrowserTopBar>
      <span className="circle close" />
      <span className="circle minimize" />
      <span className="circle fullscreen" />
      <UrlBar>{url}</UrlBar>
    </BrowserTopBar>
    {children}
  </div>
);

export default BrowserLayout;
